module.exports = __webpack_public_path__ + "static/media/Dilon_White.07a9d1c5.jpeg";